import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import broadcastService from '../../services/broadcastService';

export const fetchSegmentCount = createAsyncThunk(
  'broadcast/fetchSegmentCount',
  async (segment, { rejectWithValue }) => {
    try {
      const response = await broadcastService.getSegmentCount(segment);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || 'Failed to load segment count'
      );
    }
  }
);

export const sendBroadcast = createAsyncThunk(
  'broadcast/sendBroadcast',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await broadcastService.sendBroadcast(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || error.message || 'Failed to send notification'
      );
    }
  }
);

const initialState = {
  segmentCount: null,
  segmentCountLoading: false,
  segmentCountError: null,
  sending: false,
  sendError: null,
  lastResult: null,
};

const broadcastSlice = createSlice({
  name: 'broadcast',
  initialState,
  reducers: {
    resetForm: (state) => {
      state.segmentCount = null;
      state.segmentCountError = null;
      state.sendError = null;
      state.lastResult = null;
    },
    clearSendError: (state) => {
      state.sendError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSegmentCount.pending, (state) => {
        state.segmentCountLoading = true;
        state.segmentCountError = null;
        state.segmentCount = null;
      })
      .addCase(fetchSegmentCount.fulfilled, (state, action) => {
        state.segmentCountLoading = false;
        state.segmentCount = action.payload.count;
      })
      .addCase(fetchSegmentCount.rejected, (state, action) => {
        state.segmentCountLoading = false;
        state.segmentCountError = action.payload;
      })
      .addCase(sendBroadcast.pending, (state) => {
        state.sending = true;
        state.sendError = null;
        state.lastResult = null;
      })
      .addCase(sendBroadcast.fulfilled, (state, action) => {
        state.sending = false;
        state.lastResult = action.payload;
      })
      .addCase(sendBroadcast.rejected, (state, action) => {
        state.sending = false;
        state.sendError = action.payload;
      });
  },
});

export const { resetForm, clearSendError } = broadcastSlice.actions;
export default broadcastSlice.reducer;
